// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_624269dc87--breadcrumbs--2ghlA","link":"_624269dc87--link--12gsV","link_wrapper":"_624269dc87--link_wrapper--4Y-CU","link-active":"_624269dc87--link-active--El8SP"};